<dl
  class="eq-border-b eq-border-b-black-natural-60"
  [ngClass]="expanded ? 'eq-bg-white lg:eq-bg-transparent' : ''"
>
  <dt
    class="eq-flex eq-items-center eq-justify-between eq-text-blue-darkBlue eq-px-4 eq-py-5 eq-cursor-pointer lg:eq-py-6"
    (click)="expand()"
    [class.eq-accordion--expanded]="expanded == true"
  >
    <h3 class="eq-text-heading6-m eq-font-bold eq-max-w-[280px] lg:eq-max-w-none lg:eq-text-heading6">
      {{ data.Question }}
    </h3>
    <i
      class="eq-flex eq-items-center eq-text-[#000000] eq-icon-chevron_down eq-text-i-32"
    ></i>
  </dt>
  <dd>
    <div
      class="eq-text-body-m eq-text-blue-darkBlue lg:eq-text-body eq-faq-links eq-rich-content"
      [innerHtml]="data.Answer"
    ></div>
  </dd>
</dl>